























































import { mdiMagnify, mdiClose } from '@mdi/js';
import { Component, Prop, Vue } from 'vue-property-decorator';

import { searchStatementByNumber } from '@/api/statements';
import { RouteName } from '@/router';

@Component({
  data: () => ({
    mdiMagnify,
    mdiClose,
  }),
})
export default class HeaderSearch extends Vue {
  isShowSearchInput = false;
  searchText = '';
  items = [];
  private mixLetters = 3;

  @Prop({ default: false }) isShowSearchInputDefault!: boolean;
  @Prop({ default: true }) clearable!: boolean;

  mounted() {
    this.clear();
    this.isShowSearchInput = this.isShowSearchInputDefault;
  }

  async onChangeSearchText(value: string) {
    const data = { number: value };
    if (value && value.length > this.mixLetters) {
      await this.searchStatementByNumber(data);
    }
  }

  async searchStatementByNumber(data: any) {
    this.items = await searchStatementByNumber(data);
  }

  onClickItem(statement: any) {
    if (statement.statusCode === 'DRAFT') {
      this.$router.push({
        //@ts-ignore
        name: RouteName[statement.statementTypeCode],
        params: { statementId: statement.statementId },
      });
    } else {
      this.$router.push({
        name: RouteName.FORM_VIEW,
        params: { statementId: statement.statementId },
      });
    }
  }

  clear() {
    this.searchText = '';
    this.items = [];
    this.isShowSearchInput = false;
  }

  onClose() {
    if (this.clearable) {
      this.clear();
    }
  }
}
